var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentMangt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 46 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9103 5.92383H15.7673C14.7487 5.92383 13.915 6.75748 13.915 7.77613V10.427H19.1043C19.6664 10.427 20.123 10.8837 20.123 11.4457C20.123 12.0077 19.6663 12.4643 19.1043 12.4643H13.915V15.2042H15.5215C16.0835 15.2042 16.5401 15.6608 16.5401 16.2228C16.5401 16.7848 16.0835 17.2415 15.5215 17.2415H13.915V19.9813H15.5215C16.0835 19.9813 16.5401 20.4379 16.5401 21C16.5401 21.562 16.0835 22.0186 15.5215 22.0186H13.915V24.7585H19.1043C19.6664 24.7585 20.123 25.2151 20.123 25.7771C20.123 26.3391 19.6663 26.7958 19.1043 26.7958H13.915V29.4466C13.915 30.4653 14.7487 31.2989 15.7673 31.2989H43.9103C44.929 31.2989 45.7626 30.4653 45.7626 29.4466V7.77631C45.7626 6.75766 44.929 5.92383 43.9103 5.92383ZM22.2418 14.7759H17.5208C16.9588 14.7759 16.5022 14.3192 16.5022 13.7572C16.5022 13.1952 16.9588 12.7386 17.5208 12.7386H22.2418C22.8038 12.7386 23.2605 13.1952 23.2605 13.7572C23.2605 14.3216 22.8038 14.7759 22.2418 14.7759Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7693 5.2774H30.3255C29.4989 4.83013 28.7214 4.13226 28.061 3.11127L27.4943 2.23314C26.5717 0.807014 24.9067 0.298828 23.209 0.298828L15.7693 0.30117C14.7506 0.30117 13.917 1.13482 13.917 2.15347V6.10398C14.376 5.59582 15.0364 5.2774 15.7693 5.2774Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.62902 11.7756H19.1063C19.289 11.7756 19.4365 11.6281 19.4365 11.4454C19.4365 11.2628 19.289 11.1152 19.1063 11.1152H9.62902C9.44636 11.1152 9.29883 11.2628 9.29883 11.4454C9.29883 11.6281 9.44636 11.7756 9.62902 11.7756Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.73448 16.553H15.5228C15.7055 16.553 15.853 16.4054 15.853 16.2228C15.853 16.0401 15.7055 15.8926 15.5228 15.8926H3.73448C3.55182 15.8926 3.4043 16.0401 3.4043 16.2228C3.4043 16.4054 3.55182 16.553 3.73448 16.553Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1749 21.3303H15.5235C15.7062 21.3303 15.8537 21.1828 15.8537 21.0001C15.8537 20.8175 15.7062 20.6699 15.5235 20.6699H10.1749C9.99226 20.6699 9.84473 20.8175 9.84473 21.0001C9.84473 21.1828 9.99226 21.3303 10.1749 21.3303Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4365 25.7774C19.4365 25.5948 19.289 25.4473 19.1063 25.4473H2.51964C2.33698 25.4473 2.18945 25.5948 2.18945 25.7774C2.18945 25.9601 2.33698 26.1076 2.51964 26.1076H19.1039C19.2889 26.1076 19.4365 25.9601 19.4365 25.7774Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2416 13.4258H17.5206C17.338 13.4258 17.1904 13.5733 17.1904 13.756C17.1904 13.9386 17.338 14.0862 17.5206 14.0862H22.2416C22.4242 14.0862 22.5718 13.9386 22.5718 13.756C22.5718 13.5733 22.4242 13.4258 22.2416 13.4258Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.38135 18.6114C5.38135 18.4288 5.23382 18.2812 5.05116 18.2812H0.330186C0.147528 18.2812 0 18.4288 0 18.6114C0 18.7941 0.147528 18.9416 0.330186 18.9416H5.05116C5.23382 18.9416 5.38135 18.7941 5.38135 18.6114Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.05089 23.0586C4.86823 23.0586 4.7207 23.2061 4.7207 23.3888C4.7207 23.5714 4.86823 23.719 5.05089 23.719H7.41372C7.59637 23.719 7.7439 23.5714 7.7439 23.3888C7.7439 23.2061 7.59637 23.0586 7.41372 23.0586H5.05089Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentMangt);
export default __webpack_public_path__ + "static/media/Document Mangt.f155c701908696eae1d4972b4ce9cfcf.svg";
export { ForwardRef as ReactComponent };